import { memo } from 'react'

const isPrimitive = val => (typeof val !== 'object' || !Array.isArray(val))

const withMemo = (Component, propsToCheck = []) => {
  // https://en.reactjs.org/docs/react-api.html
  const areEqual = (prevProps, nextProps) => {
    let isEqual = true

    for (let i = 0; i < propsToCheck.length; i += 1) {
      const propToCheck = propsToCheck[i]
      isEqual = (
        isPrimitive(prevProps[propToCheck])
          ? (prevProps[propToCheck] === nextProps[propToCheck])
          : (JSON.stringify(prevProps[propToCheck]) === JSON.stringify(nextProps[propToCheck]))
      )
      if (!isEqual) break
    }
    return isEqual
  }
  return memo(Component, areEqual)
}

export default withMemo
